import React from "react";
import { Link } from "react-router-dom";

import "./EducationalProgramsIVT.css";

const items = [
  {
    subtitle: "239",
    text: (
      <React.Fragment>
        Проходной балл <br /> в 2023 (бюджет)
      </React.Fragment>
    ),
  },
  {
    subtitle: "120",
    text: (
      <React.Fragment>
        Количество бюджетных <br />
        мест на оч/ф
      </React.Fragment>
    ),
  },
  {
    subtitle: "25; 80",
    text: (
      <React.Fragment>
        Количество платных <br />
        мест на оч/ф; — заоч/ф
      </React.Fragment>
    ),
  },
  {
    subtitle: "163 160₽",
    text: "Стоимость платного обучения на оч/ф",
  },
  {
    subtitle: "63 600₽",
    text: "Стоимость платного обучения на заоч/ф",
  },
];

export default function EducationalProgramsIVT() {
  return (
    <div className="educational-program">
      <span className="individual-achivments__title">
        Институт цифровых технологий и экономики
      </span>

      <table className="educational-program__scroll-table">
        <tr className="educational-program__scroll-table-row one">
          <div className="educational-program__scroll-table-column one">
            <span className="educational-program__block-title">
              Образовательные программы: <br />
              «Информатика и вычислительная техника»
            </span>
          </div>
          <div className="educational-program__scroll-table-column two">
            <span className="educational-program__block-title sub">
              Бюджет очная
              <br />
              форма
            </span>
          </div>
          <div className="educational-program__scroll-table-column three">
            <span className="educational-program__block-title sub">
              Бюджет заочная
              <br />
              форма
            </span>
          </div>
          <div className="educational-program__scroll-table-column four">
            <span className="educational-program__block-title sub">
              Платные места
              <br />
              очная форма
            </span>
          </div>
          <div className="educational-program__scroll-table-column five">
            <span className="educational-program__block-title sub">
              Платные места
              <br />
              заочная форма
            </span>
          </div>
        </tr>
        <tr className="educational-program__scroll-table-row">
          <div className="educational-program__scroll-table-column one">
            <Link to="/business-process-management-information-systems"
              className="educational-program__block-text"
            >
              Информационные системы управления бизнес-процессами
            </Link>
          </div>
          <div className="educational-program__scroll-table-column two">
            <span className="educational-program__block-text">✓</span>
          </div>
          <div className="educational-program__scroll-table-column three">
            <span className="educational-program__block-text">—</span>
          </div>
          <div className="educational-program__scroll-table-column four">
            <span className="educational-program__block-text">✓</span>
          </div>
          <div className="educational-program__scroll-table-column five">
            <span className="educational-program__block-text">—</span>
          </div>
        </tr>
        <tr className="educational-program__scroll-table-row one">
          <div className="educational-program__scroll-table-column one">
            <Link to="/software-development-technologies"
              className="educational-program__block-text one"
            >
              Технологии разработки программного обеспечения
            </Link>
          </div>
          <div className="educational-program__scroll-table-column two">
            <span className="educational-program__block-text">✓</span>
          </div>
          <div className="educational-program__scroll-table-column three">
            <span className="educational-program__block-text">—</span>
          </div>
          <div className="educational-program__scroll-table-column four">
            <span className="educational-program__block-text">✓</span>
          </div>
          <div className="educational-program__scroll-table-column five">
            <span className="educational-program__block-text">✓</span>
          </div>
        </tr>
        <tr className="educational-program__scroll-table-row">
          <div className="educational-program__scroll-table-column one">
            <Link to="/technologies-for-the-development-of-information-systems-and-web-applications"
              className="educational-program__block-text"
            >
              Технологии разработки информационных систем и web-приложений
            </Link>
          </div>
          <div className="educational-program__scroll-table-column two">
            <span className="educational-program__block-text">✓</span>
          </div>
          <div className="educational-program__scroll-table-column three">
            <span className="educational-program__block-text">—</span>
          </div>
          <div className="educational-program__scroll-table-column four">
            <span className="educational-program__block-text">✓</span>
          </div>
          <div className="educational-program__scroll-table-column five">
            <span className="educational-program__block-text">✓</span>
          </div>
        </tr>
      </table>

      <div className="educational-program__main-block ivt">
        {items.map((item, index) => (
          <div
            className="individual-achivments__text-block"
            key={String(index)}
          >
            <span className="individual-achivments__subtitle">
              {item.subtitle}
            </span>
            <span className="individual-achivments__text">{item.text}</span>
          </div>
        ))}
      </div>
    </div>
  );
}
